import { render, staticRenderFns } from "./DianJinPanel.vue?vue&type=template&id=494f5fbd&scoped=true&"
import script from "./DianJinPanel.vue?vue&type=script&lang=js&"
export * from "./DianJinPanel.vue?vue&type=script&lang=js&"
import style0 from "./DianJinPanel.vue?vue&type=style&index=0&id=494f5fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f5fbd",
  null
  
)

export default component.exports